
























import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util';
import ListBase from '@/lib/listbase';
import PageRequest from '@/store/entities/page-request';
import ListView from '@/components/helper/list-view.vue';
import FormBase from '@/components/helper/form-base.vue';
import DealerForm from './dealer-form.vue';
import DealerMap from './map.vue';

class PageDealerRequest extends PageRequest {
    zone: number = null;
    search: string = '';
}

@Component({
    components: { ListView, DealerForm, FormBase, DealerMap }
})
export default class Dealers extends ListBase {
    entity: string = 'dealer';
    pagerequest: PageDealerRequest = new PageDealerRequest();
    views: Array<any> = [{ code: "map", title: "Ver Mapa", icon: "map" }];
    currentView: string = 'list';
    filterForm: boolean = true;

    filterItems = [
        this.gItem({ type: 'object', prop: 'zone', label: 'Zona', hideDetails: true, onchange: this.afterSave, size: 3 }),
        this.gItem({ type: 'text', prop: 'search', label: 'Buscar por Nombre o Codigo', hideDetails: true, onchange: this.afterSave, size: 3 }),
        this.gItem({ type: 'spacer', size: 6 }),
    ]

    columns = [
        this.gCol('code', 'Codigo SIMA', 'text'),
        this.gCol('code2', 'Codigo 2', 'text'),
        this.gCol('fullname', 'Nombre', 'text'),
        this.gCol('business_name', 'Razon Social', 'text'),
        this.gCol('document', 'RUC', 'text'),
        this.gCol('active', 'Habilitado', 'text'),
        this.defaultActions('edit')
    ]

    changeView(view) {
        this.currentView = view;
    }

    edit() {
        this.modalShow = !this.modalShow;
    }
    create() {
        this.modalShow = !this.modalShow;
    }
    async afterSave() {
        let list: any = this.$refs.listView
        await list.getpage();
    }     

    mounted() {
        this.$store.dispatch({ type: 'department/getAllActive' });
        this.$store.dispatch({ type: 'dealer/getAllActive'});
    }

    created() {
        
    }
}